/* Utils Initialiser */
// import { qs, qsa, addGlobalEventListener } from "./utils.js";

/* Swiper Initialiser */
const swiperContainerP = document.getElementsByClassName('carousel_product')
for (var i = 0; i < swiperContainerP.length; i++) {
	swiperContainerP[i].classList.add('swiperP' + i)

	const swiperPage = swiperContainerP[i].querySelector('.swiper-pagination')

	if (swiperPage) {
		swiperPage.classList.add('pageP' + i)
	}

	var mySwiperP = new Swiper('.swiperP' + i, {
		direction: 'horizontal',
		// loop: true,
		autoHeight: false,
		centeredSlides: false,
		freeMode: true,
		slidesPerView: 1,
		speed: 500,
		pagination: {
			el: '.pageP' + i,
			type: 'progressbar'
		},
		mousewheel: {
			invert: false,
			forceToAxis: true
		},

		breakpoints: {
			1024: {
				slidesPerView: 1
			}
		}
	})
}

const swiperContainerS = document.getElementsByClassName('carousel_scroll')
for (var i = 0; i < swiperContainerS.length; i++) {
	swiperContainerS[i].classList.add('swiperS' + i)

	const swiperScroll = swiperContainerS[i].querySelector('.swiper-scrollbar')

	if (swiperScroll) {
		swiperScroll.classList.add('scrollS' + i)
	}

	var mySwiperS = new Swiper('.swiperS' + i, {
		direction: 'horizontal',
		loop: false,
		autoheight: false,
		slidesPerView: 'auto',
		resistance: true,
		resistanceRatio: 0,
		speed: 700,
		simulateTouch: true,
		grabCursor: true,
		preloadImages: true,
		centeredSlides: false,
		pagination: {
			el: '.scrollS' + i,
			type: 'progressbar'
		},
		scrollbar: {
			el: '.scrollS' + i,
			draggable: true
		},
		mousewheel: {
			invert: false,
			forceToAxis: true
		},
		freeMode: {
			enabled: true,
			momentum: true,
			momentumBounce: false
		}
	})
}

const swiperContainerAn = document.querySelectorAll('.carousel_announce')
for (var i = 0; i < swiperContainerAn.length; i++) {
	swiperContainerAn[i].classList.add('swiperAn' + i)

	var mySwiperAn = new Swiper('.swiperAn' + i, {
		slidesPerView: 'auto',
		autoHeight: false,
		centeredSlides: true,
		loop: true,
		allowTouchMove: false,
		preventClicks: false,
		preventClicksPropagation: false,
		autoplay: {
			delay: 1,
			pauseOnMouseEnter: false,
			disableOnInteraction: false
		},
		// freeMode: true,
		spaceBetween: 250,
		speed: 20000
	})
}

const swiperContainerA = document.querySelectorAll('.carousel_auto')
for (var i = 0; i < swiperContainerA.length; i++) {
	swiperContainerA[i].classList.add('swiperA' + i)

	var mySwiperA = new Swiper('.swiperA' + i, {
		slidesPerView: 'auto',
		autoHeight: false,
		loop: true,
		allowTouchMove: false,
		preventClicks: false,
		preventClicksPropagation: false,
		preloadImages: true,
		autoplay: {
			delay: 1,
			pauseOnMouseEnter: false,
			disableOnInteraction: false
		},
		speed: 5000
	})
}

const swiperContainerGalleryBlock =
	document.getElementsByClassName('carousel_gallery')
for (var i = 0; i < swiperContainerGalleryBlock.length; i++) {
	swiperContainerGalleryBlock[i].classList.add('swiperP' + i)

	const swiperPage =
		swiperContainerGalleryBlock[i].querySelector('.swiper-pagination')

	if (swiperPage) {
		swiperPage.classList.add('pageP' + i)
	}

	var mySwiperP = new Swiper('.swiperP' + i, {
		direction: 'horizontal',
		// loop: true,
		freeMode: true,
		autoHeight: false,
		centeredSlides: false,
		slidesPerView: 1.5,
		spaceBetween: 8,
		speed: 500,
		pagination: {
			el: '.pageP' + i,
			type: 'progressbar'
		},
		mousewheel: {
			invert: false,
			forceToAxis: true
		},

		breakpoints: {
			720: {
				slidesPerView: 2.5
			}
		}
	})
}

/* Product Card Hover */
function hoverCard(e, colour) {
	var newColour = e.parentNode.querySelector("[data-colour='" + colour + "']")

	e.classList.remove('active')
	newColour.classList.add('active')
}

/* Toggle Class (Generic) */
function toggleClass(modalName, check) {
	if (check) {
		var modalActive = modalName
	} else {
		var modalActive = document.querySelector(modalName)
	}
	modalActive.classList.toggle('active')
}

function addClass(modalName) {
	var modalActive = document.querySelector(modalName)
	modalActive.classList.add('active')
}

function removeClass(modalName) {
	var modalActive = document.querySelector(modalName)
	modalActive.classList.remove('active')
}

/* Close Popup */
function closePopup(modalName, cookieName) {
	var modalActive = document.getElementById(modalName)
	modalActive.classList.remove('active')

	var timeToAdd = 3 * 24 * 60 * 60 * 1000
	var date = new Date()
	var expiryTime = parseInt(date.getTime()) + timeToAdd
	date.setTime(expiryTime)
	var utcTime = date.toUTCString()

	document.cookie = cookieName + '=closed; expires=' + utcTime + '; path=/'

	if (modalName == 'bar') {
		document.documentElement.style.setProperty('--Hb', '0px')
	}
}

/* Radio Changer */
var availVar = document.querySelectorAll('.product-variant_avail')
var pRadio = document.querySelectorAll('.product__info-radio')

if (pRadio) {
	if (availVar) {
		availVar.forEach((item) => item.click())
	} else {
		pRadio.forEach((item) => item.click())
	}
}

function radioChanger(e, radios, price, buttons, ap) {
	var priceContainer = document.querySelector(price)
	var radioItems = document.querySelectorAll(radios)
	var buttonsContainer = document.querySelector(buttons)
	var priceApContainer = document.querySelector(ap)

	var priceOg = e.target.getAttribute('data-price')
	var priceSale = e.target.getAttribute('data-compare')
	var priceAp = e.target.getAttribute('data-price-ap')
	var availability = e.target.getAttribute('data-availability')

	for (i = 0; i < radioItems.length; i++) {
		radioItems[i].parentNode.classList.remove('active')
	}
	e.target.parentNode.classList.add('active')

	priceContainer.querySelector('#product-price-og').innerHTML = '$' + priceOg
	if (priceApContainer) {
		priceApContainer.innerHTML = '$' + priceAp
	}

	if (priceOg < priceSale) {
		priceContainer.setAttribute('data-sale', 'true')
		priceContainer.querySelector('#product-price-sale').innerHTML =
			'$' + priceSale
	} else {
		priceContainer.setAttribute('data-sale', 'false')
	}

	buttonsContainer.setAttribute('data-status', availability)
}

// function radioStock(e, radios) {
//     var radio = document.querySelectorAll(radios);

//     for (i = 0; i < radio.length; i++) {
//         radio[i].parentNode.classList.remove("active")
//     }

//     e.target.parentNode.classList.add("active");
// }

/* Open Cart */
var body = document.querySelector('body')

function cartOpen() {
	body.classList.add('js-my-cart-open')
}

/* Open Size Guide */

function sizeGuideOpen() {
	body.classList.add('js-size-guide-open')
}

/* Resize Select */
const resizingSelect = document.querySelector('.resizing-select')
const helperElement = document.querySelector('.helper-element')

if (resizingSelect) {
	function initResize() {
		helperElement.innerHTML =
			resizingSelect.querySelector('option:checked').innerText
		resize(helperElement.offsetWidth)
	}

	function resize(width) {
		const root = document.documentElement
		root.style.setProperty('--dynamic-size', `${width}px`)
	}

	initResize()
}

/* Details Animator */
const details = document.querySelectorAll('details summary')

if (details) {
	details.forEach((targetDetail) => {
		targetDetail.addEventListener('click', function (e) {
			if (targetDetail.parentNode.hasAttribute('open')) {
				e.preventDefault()
				targetDetail.parentNode.classList.add('closing')
				setTimeout(() => {
					targetDetail.parentNode.removeAttribute('open')
					targetDetail.parentNode.classList.remove('closing')
				}, 390)
			}
		})
	})
}

/* Audio Player */
const audioPlayers = document.querySelectorAll('.audio_player')

for (var i = 0; i < audioPlayers.length; i++) {
	const audioPlayer = audioPlayers[i].querySelector('.audio_player-container')
	const audio = new Audio(audioPlayer.getAttribute('data-src'))

	console.dir(audio)

	audio.addEventListener(
		'loadeddata',
		() => {
			audioPlayer.querySelector(
				'.audio_player-time .audio_player-length'
			).textContent = getTimeCodeFromNum(audio.duration)
		},
		false
	)

	const timeline = audioPlayer.querySelector('.audio_player-timeline')
	timeline.addEventListener(
		'click',
		(e) => {
			const timelineWidth = window.getComputedStyle(timeline).width
			const timeToSeek = (e.offsetX / parseInt(timelineWidth)) * audio.duration
			audio.currentTime = timeToSeek
		},
		false
	)

	setInterval(() => {
		const progressBar = audioPlayer.querySelector('.audio_player-progress')
		progressBar.style.width = (audio.currentTime / audio.duration) * 100 + '%'
		audioPlayer.querySelector(
			'.audio_player-time .audio_player-current'
		).textContent = getTimeCodeFromNum(audio.currentTime)
	}, 500)

	const playBtn = audioPlayer.querySelector('.audio_player-toggle_play')
	playBtn.addEventListener(
		'click',
		() => {
			if (audio.paused) {
				playBtn.classList.remove('active')
				playBtn.classList.add('inactive')
				audio.play()
			} else {
				playBtn.classList.remove('inactive')
				playBtn.classList.add('active')
				audio.pause()
			}
		},
		false
	)

	const audioBtn = audioPlayer.querySelector('.audio_player-toggle_volume')

	audioBtn.addEventListener('click', () => {
		audio.muted = !audio.muted
		if (audio.muted) {
			audioBtn.classList.remove('active')
			audioBtn.classList.add('inactive')
		} else {
			audioBtn.classList.add('active')
			audioBtn.classList.remove('inactive')
		}
	})

	function getTimeCodeFromNum(num) {
		let seconds = parseInt(num)
		let minutes = parseInt(seconds / 60)
		seconds -= minutes * 60
		const hours = parseInt(minutes / 60)
		minutes -= hours * 60

		if (hours === 0) return `${minutes}:${String(seconds % 60).padStart(2, 0)}`
		return `${String(hours).padStart(2, 0)}:${minutes}:${String(
			seconds % 60
		).padStart(2, 0)}`
	}
}

/* Orphan Remove and LSEP Removal */
var nbspSelectors = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'a', 'span']
var nbspWordMin = 10 //Minimum words within parent tag to activate script

// nbspSelectors.forEach(function (selector) {
//     var nbspElements = document.querySelectorAll(selector);
//     nbspElements.forEach(function (element) {
//         var wordCount = element.innerHTML.split(" ").length;
//         element.innerHTML = element.innerHTML.replace(/\u2028/g, "");
//         element.innerHTML = element.innerHTML.replace(/&#8232;/g, "");
//         if (wordCount >= nbspWordMin) {
//             element.innerHTML = element.innerHTML.replace(/ ([^ ]*)$/, "&nbsp;$1");
//         }
//     });
// });

window.addEventListener('load', (event) => {
	var radio = document.querySelectorAll('.product__info-radio')
	var cvcPrice = document.querySelectorAll('.product__info-cvc')

	if (radio && cvcPrice) {
		for (var i = 0; i < radio.length; i++) {
			radio[i].setAttribute(
				'data-price',
				cvcPrice[i].innerHTML.replace('$', '')
			)
		}
	}
})

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({})

function initGiftBoxListeners() {
	const giftBoxInfo = document.querySelector('#cartGiftBoxInfo')
	const giftBoxInfoBg = document.querySelector('#cartGiftBoxInfoBg')
	const giftBoxInfoButton = document.querySelector('#cartGiftBoxInfoButton')

	if (giftBoxInfo && giftBoxInfoBg) {
		giftBoxInfoButton.addEventListener('mouseover', () => {
			giftBoxInfo.classList.add('active')
			giftBoxInfoBg.classList.add('active')
		})
		giftBoxInfoBg.addEventListener('mouseover', () => {
			giftBoxInfo.classList.remove('active')
			giftBoxInfoBg.classList.remove('active')
		})
	}
}
initGiftBoxListeners()

liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
	subscribeToResult(() => {
		initGiftBoxListeners()
	})
})

const shopNavigations = document.querySelectorAll('[data-shop-menu]')

shopNavigations.forEach((navigation) => {
	const titles = navigation.querySelectorAll('[data-shop-menu-title]')

	titles.forEach((title) => {
		const matching = title.dataset.shopMenuTitle
		const menu = navigation.querySelector(`[data-shop-menu-nav="${matching}"]`)

		title.addEventListener('mouseover', (e) => {
			if (menu) {
				const exTitle = navigation.querySelector(
					'[data-shop-menu-title].active'
				)
				const exMenu = navigation.querySelector('[data-shop-menu-nav].active')

				if (exTitle != title) {
					exTitle && exTitle.classList.remove('active')
				}
				if (exMenu != menu) {
					exMenu && exMenu.classList.remove('active')
				}

				title.classList.add('active')
				menu.classList.add('active')
			}
		})
	})

	const rotatingBanners = navigation.querySelectorAll(
		'[data-shop-rotating-banner]'
	)
	const delay = 6000

	let idx = 0
	const max = rotatingBanners.length - 1

	setInterval(() => {
		if (idx == max) {
			idx = 0
		} else {
			idx++
		}
		const ex = navigation.querySelector('[data-shop-rotating-banner].active')

		if (ex) {
			ex.classList.remove('active')
			ex.setAttribute('aria-hidden', true)
		}

		if (rotatingBanners[idx]) {
			rotatingBanners[idx].classList.add('active')
			rotatingBanners[idx].setAttribute('aria-hidden', false)
		}
	}, delay)
})

const mobileShopMenus = document.querySelectorAll('[data-mobile-shop]')

mobileShopMenus.forEach((menu) => {
	const buttons = menu.querySelectorAll('[data-mobile-shop-child]')
	const menus = menu.querySelectorAll('[data-mobile-shop-menu]')

	buttons.forEach((button) => {
		button.addEventListener('click', (e) => {
			e.preventDefault()
			const type = button.dataset.mobileShopChild
			const matchingMenu = menu.querySelector(
				`[data-mobile-shop-menu="${type}"]`
			)
			const currentMenu = menu.querySelector(`[data-mobile-shop-menu].active`)
			const currentButton = menu.querySelector(
				`[data-mobile-shop-child].active`
			)

			if (currentMenu) {
				if (currentMenu != matchingMenu) {
					currentMenu.classList.remove('active')
				}
			}
			if (currentButton) {
				if (currentButton != button) {
					currentButton.classList.remove('active')
				}
			}

			button.classList.toggle('active')
			matchingMenu && matchingMenu.classList.toggle('active')
		})
	})
})

const mobileRotatingBanners = document.querySelectorAll(
	'[data-mobile-shop-rotating-banner]'
)

if (mobileRotatingBanners.length > 0) {
	const delay = 6000

	let idx = 0
	const max = mobileRotatingBanners.length - 1

	setInterval(() => {
		if (idx == max) {
			idx = 0
		} else {
			idx++
		}

		const ex = document.querySelector(
			'[data-mobile-shop-rotating-banner].active'
		)

		if (ex) {
			ex.classList.remove('active')
			ex.setAttribute('aria-hidden', true)
		}

		if (mobileRotatingBanners[idx]) {
			mobileRotatingBanners[idx].classList.add('active')
			mobileRotatingBanners[idx].setAttribute('aria-hidden', false)
		}
	}, delay)
}
